import {buildFeatureUrl, FeatureName} from '@hproduce/suite-core'

export const getStoppagesListPath = (plantId: string, upmPlantId: string) => {
  const featureName: FeatureName = 'StoppageList'
  const baseUrl = buildFeatureUrl(featureName, upmPlantId)
  const filters = [{property: 'plantId', values: [plantId], operation: 'In'}]
  const search = new URLSearchParams({filters: JSON.stringify(filters), page: '0'}).toString()

  return `${baseUrl}?${search}`
}

export const getShiftSummaryPath = (upmPlantId: string) => {
  const featureName: FeatureName = 'ShiftSummary'
  const basePath = buildFeatureUrl(featureName, upmPlantId)

  return basePath
}
